/**
 * /admin/integrations — Connector registry (route shell).
 * Screen impl in `./integrations-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/integrations')({
  component: lazyRouteComponent(
    () => import('./integrations-screen'),
    'AdminIntegrations',
  ),
});
